import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initTelegram } from './telegram';
import './styles.css';

initTelegram();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Не найден корневой элемент');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
